module.exports = __webpack_public_path__ + "static/concrete-removal-banner-b718e51b2bd803afc34dcbe4ce9045e1.jpg";